import React from 'react';

const HighlightTag = ({ children }) => <span className='font-weight-semibold text-black'>{children}</span>;

export { HighlightTag };
